import * as React from 'react';
import DisplayLongDescriptionAndVariantMFRName
    from "../../../../component/Product/DisplayLongDescriptionAndVariantMFRName";
import CartRepository from "../../../../repository/CartRepository";
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';

const Listing = (props) => {
    const { CART_PRODUCT_DATA, CART_DATA } = props;
    const { getCartProductInventoryQuantityByERPPartNumber, getCartProductInventoryLeadTimeByERPPartNumber } = props;
    return (
        <>
            <table className="table table-outline rounded-0">
                <thead className="bg-light">
                    <tr>
                        <th className="border-0 text-none font-12">Product(s)</th>
                        <th className="border-0 text-none font-12">Requested Quantity</th>
                        <th className="border-0 text-none font-12">Backorder Quantity</th>
                    </tr>
                </thead>
                <tbody className="border-top-0">
                    {Object.entries(CART_PRODUCT_DATA).length > 0 && CART_DATA && Object.entries(CART_DATA).length > 0 &&
                        CART_DATA.map((v, i) => (
                            <React.Fragment key={v.ERPPartNumber}>
                                {new CartRepository().getUnadjustedQuantity(v.ERPPartNumber) > 0 &&
                                    <tr>
                                        <td className="align-top">
                                            <div className="inventory-product-info">
                                                {CART_PRODUCT_DATA[v.ERPPartNumber] !== undefined &&
                                                    <div className="inventory-product-name">
                                                        <NavigateToPDP data={{
                                                            ManufacturerName: v?.manufacturerName,
                                                            ERPMFRPartNumber: CART_PRODUCT_DATA[v?.ERPPartNumber]?.ERPMFRPartNumber,
                                                            ItemNumber: v?.itemNumber,
                                                        }} >
                                                            <b>{CART_PRODUCT_DATA[v.ERPPartNumber].ERPMFRPartNumber}</b>
                                                        </NavigateToPDP>
                                                    </div>
                                                }
                                                {/* {CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true &&
                                                    <div className="inventory-product-info">
                                                        <span className="mandatory">Can't add Quantity to Backorder for Obsolete Item.</span>
                                                    </div>
                                                } */}
                                                <div className="inventory-product-by">
                                                    <DisplayLongDescriptionAndVariantMFRName
                                                        currentProduct={CART_PRODUCT_DATA[v.ERPPartNumber]} />
                                                </div>
                                                <div className="inventory-product-stock"><b>In
                                                    Stock: {getCartProductInventoryQuantityByERPPartNumber(v.ERPPartNumber)}</b>
                                                </div>
                                                <div className="inventory-product-lead">Lead Time From
                                                    Supplier: {getCartProductInventoryLeadTimeByERPPartNumber(v.ERPPartNumber)}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="align-top">
                                            {/* {(CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true) === false && */}
                                            <span>{v.quantity}</span>
                                            {/* } */}
                                        </td>
                                        <td className="align-top">
                                            {/* {(CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true) === false &&
                                                <span>{v.quantity - getCartProductInventoryQuantityByERPPartNumber(v.ERPPartNumber)}</span>
                                            }
                                             */}
                                            {(CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === false) ?
                                                <span>{v.quantity - getCartProductInventoryQuantityByERPPartNumber(v.ERPPartNumber)}</span>
                                                : <span>0
                                                    <br />
                                                    <span className="mandatory">Unable to back order Obsolete items</span>

                                                </span>
                                            }
                                        </td>
                                    </tr>
                                }
                            </React.Fragment>
                        ))
                    }
                </tbody>
            </table>
        </>
    );
}

export default Listing;